var _defs, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMizarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 146.93 169.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-5{fill:url(#linear-gradient-5);}.cls-6{fill:url(#linear-gradient-6);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 73.72,
    y1: 180.41,
    x2: 73.19,
    y2: -17.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a1e61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#1b2468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#22418a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#275ba7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#2b6fbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#2f7fd2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#318ade"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#3390e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#3392e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#3392e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#3392e8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 73.47,
    y1: 20.98,
    x2: 73.47,
    y2: 66.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#3392e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#3697e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#3fa4ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#4ebaf0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#63d9f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7cfffe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 16.14,
    y1: 87.38,
    x2: 128.23,
    y2: 88.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3392e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#4bb6ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#61d6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#70edfa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#79fafd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#7cfffe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#7afcfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#73f1fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#67dff8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#56c6f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#41a7ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3392e8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 39.35,
    y1: 124.35,
    x2: 39.06,
    y2: 73.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3392e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#328fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#3086da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#2d77c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#2962b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#234690"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#1c2569"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1e61"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 107.7,
    y1: 72.72,
    x2: 107.7,
    y2: 122.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a1e61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#1c2569"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#234690"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#2962b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#2d77c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#3086da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#328fe5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3392e8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 73.3,
    y1: 150.23,
    x2: 73.64,
    y2: 111.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3392e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#328de2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#2f80d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#2a69b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#234a94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#1b2266"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1e61"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73.47,5.78,141.93,45.3v79.06L73.47,163.88,5,124.36V45.3L73.47,5.78m0-5.78L71,1.44,2.5,41,0,42.42v84.83l2.5,1.44L71,168.22l2.51,1.44,2.5-1.44,68.46-39.53,2.5-1.44V42.42L144.43,41,76,1.44,73.47,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "73.47 18.95 27.83 45.3 73.47 71.66 119.11 45.3 73.47 18.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "16.41 51.89 73.47 84.83 130.52 51.89 130.52 117.77 119.11 124.36 119.11 71.66 73.47 98.01 27.83 71.66 27.83 124.36 16.41 117.77 16.41 51.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "27.83 124.36 50.65 111.18 50.65 84.83 27.83 71.66 27.83 124.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "119.11 71.66 119.11 124.36 96.29 111.18 96.29 84.83 119.11 71.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "73.47 150.71 107.7 130.94 73.47 111.18 39.24 130.94 73.47 150.71"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMizarIcon);
export default __webpack_public_path__ + "static/media/mizar_icon.979d4de2e4744789e2b242cc62c9b41f.svg";
export { ForwardRef as ReactComponent };